import * as Yup from 'yup';
import { InternalIntegrationSetting } from 'models/InternalIntegrationSetting';

export const editRateMultiplierFormSchema = () =>
  Yup.object({
    rateMultiplier: Yup.number().useNaNAsNull().min(-100).required(),
  });

export type EditRateMultiplierFormValues = Yup.InferType<
  ReturnType<typeof editRateMultiplierFormSchema>
>;

export const getFormDefaultValues = ({
  integrationSettings,
}: {
  integrationSettings: InternalIntegrationSetting;
}): EditRateMultiplierFormValues => {
  return {
    rateMultiplier: integrationSettings.agencySettings.rateMultiplier ?? 0,
  };
};
